



















import ApiClient from '@/js/api.js'
import PopupTemplate from '@/views/templates/africadogs/PopupTemplate.vue'
import QuizAfricaDogs from '@/views/organisms/QuizAfricaDogs.vue'

export default
  components: {
    PopupTemplate
    QuizAfricaDogs
  }

  data: () ->
    baseColor: '#ECC236'
    point: 0
    mode: 0
    quizResult: 0
    quizData:
      hukidashi: [
        'アート・ユニの西田さんが染める布'
        '「広幅（ひろはば）」のサイズは次のうちのどれでしょうか？'
      ]
      quiz: [
        'お台場の実物大ガンダムの高さに近い18m'
        'パリの凱旋門の奥行きに近い23m'
        'バスケットコートの長辺に近い28m'
      ]
      success_message: [
        '広幅のサイズは23m。'
        '広い場所が必要となる「広幅」で布を染めることができる工房は今は希少なんだよ。'
      ]
      answer: 2

  methods: {
    closePopup: () ->
      m = @mode
      if m == 0
        m = 2
      @$emit('closePopup', m)
    success: () ->
      @mode = 3
      @quizResult = 2
      @baseColor = '#F699AB'
      api = new ApiClient()
      param =
        'point_code': 'p3-8'
      data = await api.post('/member/point/save', true, param)
      @point = data.point
      if @point > 0
        @$emit('addPoint', @point)
      @$emit('success')
    miss: () ->
      @baseColor = '#7BCAD8'
      @mode = 2
      @quizResult = 1
  }
